import { render, staticRenderFns } from "./OngoingHeader.vue?vue&type=template&id=16462bb1&scoped=true&lang=pug&"
import script from "./OngoingHeader.vue?vue&type=script&lang=js&"
export * from "./OngoingHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16462bb1",
  null
  
)

/* custom blocks */
import block0 from "./OngoingHeader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
